export default __webpack_public_path__ + "static/media/icon-energy.5b370532.svg";